"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.profileApiWatchers = profileApiWatchers;
var _effects = require("redux-saga/effects");
var _sagas = require("../../../auth/login/redux/sagas");
var api = _interopRequireWildcard(require("../api/api"));
var actions = _interopRequireWildcard(require("./actions"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function* callCompleteProfile(params) {
  try {
    yield (0, _effects.put)(actions.COMPLETE_PROFILE_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.completeProfile, params.data.params, tokenData);
    yield (0, _effects.put)(actions.COMPLETE_PROFILE_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.COMPLETE_PROFILE_API.failure(err));
    params.data.onFailure(err);
  }
}
function* callGuestCheckoutRegister(params) {
  try {
    yield (0, _effects.put)(actions.GUEST_CHECKOUT_REGISTER_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.guestCheckoutRegister, params.data.params, tokenData);
    yield (0, _effects.put)(actions.GUEST_CHECKOUT_REGISTER_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GUEST_CHECKOUT_REGISTER_API.failure(err));
    params.data.onFailure(err);
  }
}
function* callGetPatientProfile(params) {
  const {
    showLoader = true
  } = params === null || params === void 0 ? void 0 : params.data;
  try {
    if (showLoader) {
      yield (0, _effects.put)(actions.GET_PATIENT_PROFILE_API.request());
    }
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getPatientProfile, params.data.params, tokenData);
    yield (0, _effects.put)(actions.GET_PATIENT_PROFILE_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_PATIENT_PROFILE_API.failure(err));
    params.data.onFailure(err);
  }
}
function* callGetPatientProfileList(params) {
  const {
    phone,
    showLoader = true
  } = params.data;
  try {
    var _mainResponse$entry$;
    if (showLoader) {
      yield (0, _effects.put)(actions.GET_PATIENT_PROFILE_LIST_API.request());
    }
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.callPatientProfileListApi, phone, tokenData);
    yield (0, _effects.put)(actions.GET_PATIENT_PROFILE_LIST_API.success(mainResponse));
    const referralEligibility = mainResponse === null || mainResponse === void 0 || (_mainResponse$entry$ = mainResponse.entry[0]) === null || _mainResponse$entry$ === void 0 || (_mainResponse$entry$ = _mainResponse$entry$.resource) === null || _mainResponse$entry$ === void 0 || (_mainResponse$entry$ = _mainResponse$entry$.extension) === null || _mainResponse$entry$ === void 0 ? void 0 : _mainResponse$entry$.some(e => e.url === 'referralEligibility' && e.valueBoolean);
    yield (0, _effects.put)(actions.SET_REFERRAL_ELIGIBILITY_API.success({
      referralEligibility: referralEligibility
    }));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_PATIENT_PROFILE_LIST_API.failure(err));
    params.data.onFailure(err);
  }
}
function* callEditPatientProfile(params) {
  try {
    yield (0, _effects.put)(actions.EDIT_PROFILE_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.editProfile, params.data.params, tokenData);
    yield (0, _effects.put)(actions.EDIT_PROFILE_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.EDIT_PROFILE_API.failure(err));
    params.data.onFailure(err);
  }
}
function* callDeletePatientProfile(params) {
  try {
    yield (0, _effects.put)(actions.DELETE_PROFILE_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.deleteProfile, params.data.params, tokenData);
    yield (0, _effects.put)(actions.DELETE_PROFILE_API.success({}));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.DELETE_PROFILE_API.failure(err));
    params.data.onFailure(err);
  }
}
function* checkPatientInHis(params) {
  const {
    userId
  } = params.data.params;
  try {
    yield (0, _effects.put)(actions.CHECK_PATIENT_IN_HIS_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.checkPatientInHis, userId, tokenData);
    yield (0, _effects.put)(actions.CHECK_PATIENT_IN_HIS_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.CHECK_PATIENT_IN_HIS_API.failure(err));
    params.data.onFailure(err);
  }
}
function* checkPatientInAkhilHis(params) {
  try {
    yield (0, _effects.put)(actions.CHECK_PATIENT_IN_AKHILHIS_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.checkPatientInAkhilHis, params.data.params, tokenData);
    yield (0, _effects.put)(actions.CHECK_PATIENT_IN_AKHILHIS_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.CHECK_PATIENT_IN_AKHILHIS_API.failure(err));
    params.data.onFailure(err);
  }
}
function* familyMember(params) {
  const {
    mobile
  } = params.data;
  try {
    yield (0, _effects.put)(actions.FAMILY_MEMBER_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.familyMember, mobile, tokenData);
    yield (0, _effects.put)(actions.FAMILY_MEMBER_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.FAMILY_MEMBER_API.failure(err));
    params.data.onFailure(err);
  }
}
function* callAddFamilyMember(params) {
  try {
    yield (0, _effects.put)(actions.ADD_FAMILY_MEMBER_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.addFamilyMembers, params === null || params === void 0 ? void 0 : params.data, tokenData);
    yield (0, _effects.put)(actions.ADD_FAMILY_MEMBER_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.ADD_FAMILY_MEMBER_API.failure(err));
    params.data.onFailure(err);
  }
}
function* guestCheckoutAddUserInfo(params) {
  try {
    yield (0, _effects.put)(actions.GUEST_CHECKOUT_ADD_USER_INFO_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.guestCheckoutAddUserInfo, params.data.params, tokenData);
    yield (0, _effects.put)(actions.GUEST_CHECKOUT_ADD_USER_INFO_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GUEST_CHECKOUT_ADD_USER_INFO_API.failure(err));
    params.data.onFailure(err);
  }
}
function* getGuestUserRegistrationStatus(params) {
  var _params$data;
  const {
    userId
  } = params === null || params === void 0 || (_params$data = params.data) === null || _params$data === void 0 ? void 0 : _params$data.params;
  try {
    // yield put(actions.GET_GUEST_USER_REGISTRATION_STATUS_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getGuestUserRegistrationStatus, userId, tokenData);
    yield (0, _effects.put)(actions.GET_GUEST_USER_REGISTRATION_STATUS_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_GUEST_USER_REGISTRATION_STATUS_API.failure(err));
    params.data.onFailure(err);
  }
}
function* profileApiWatchers() {
  yield (0, _effects.takeLatest)(actions.COMPLETE_PROFILE, callCompleteProfile);
  yield (0, _effects.takeLatest)(actions.GUEST_CHECKOUT_REGISTER, callGuestCheckoutRegister);
  yield (0, _effects.takeLatest)(actions.GUEST_CHECKOUT_ADD_USER_INFO, guestCheckoutAddUserInfo);
  yield (0, _effects.takeEvery)(actions.GET_PATIENT_PROFILE, callGetPatientProfile);
  yield (0, _effects.takeEvery)(actions.GET_PATIENT_PROFILE_LIST, callGetPatientProfileList);
  yield (0, _effects.takeLatest)(actions.EDIT_PROFILE, callEditPatientProfile);
  yield (0, _effects.takeLatest)(actions.DELETE_PROFILE, callDeletePatientProfile);
  yield (0, _effects.takeLatest)(actions.CHECK_PATIENT_IN_HIS, checkPatientInHis);
  yield (0, _effects.takeLatest)(actions.CHECK_PATIENT_IN_AKHILHIS, checkPatientInAkhilHis);
  yield (0, _effects.takeLatest)(actions.FAMILY_MEMBER, familyMember);
  yield (0, _effects.takeLatest)(actions.ADD_FAMILY_MEMBER, callAddFamilyMember);
  yield (0, _effects.takeLatest)(actions.GET_GUEST_USER_REGISTRATION_STATUS, getGuestUserRegistrationStatus);
}